export { default } from './ProductDetailRight';
